export default "__VITE_ASSET__pUlsMBYs__"